"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _ReportBlockTradeContainer = _interopRequireDefault(require("./ReportBlockTradeContainer"));
var _ConfirmBlockTradeModalContainer = _interopRequireDefault(require("../ConfirmBlockTradeModal/ConfirmBlockTradeModalContainer"));
require("./ReportBlockTradeSidePaneComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('report-block-trade-sidepane');
var ReportBlockTradeSidePane = /*#__PURE__*/function (_React$Component) {
  function ReportBlockTradeSidePane() {
    _classCallCheck(this, ReportBlockTradeSidePane);
    return _callSuper(this, ReportBlockTradeSidePane, arguments);
  }
  _inherits(ReportBlockTradeSidePane, _React$Component);
  return _createClass(ReportBlockTradeSidePane, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var t = this.props.t;
      this.props.onSidePaneOpen({
        title: t("Report Block Trade"),
        customClass: baseClasses(),
        classModifiers: 'with-tabs'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        form = _this$props.form,
        setBoughtReport = _this$props.setBoughtReport,
        setSoldReport = _this$props.setSoldReport,
        clearReportBlockTrade = _this$props.clearReportBlockTrade;
      var boughtTabModifier = (form && form.values.side === _orderEntryFormConstants.buyValue || !form) && 'bought-selected';
      var soldTabModifier = form && form.values.side === _orderEntryFormConstants.sellValue && 'sold-selected';
      var selectBoughtTab = function selectBoughtTab() {
        clearReportBlockTrade();
        setBoughtReport();
      };
      var selectSoldTab = function selectSoldTab() {
        clearReportBlockTrade();
        setSoldReport();
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('tab-container')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('tab', boughtTabModifier),
        onClick: selectBoughtTab
      }, t("Bought")), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('tab', soldTabModifier),
        onClick: selectSoldTab
      }, t("Sold"))), /*#__PURE__*/_react["default"].createElement(_ReportBlockTradeContainer["default"], {
        useNewForm: (0, _get["default"])(this, 'props.useNewForm', false)
      }), /*#__PURE__*/_react["default"].createElement(_ConfirmBlockTradeModalContainer["default"], null));
    }
  }]);
}(_react["default"].Component);
ReportBlockTradeSidePane.propTypes = {
  setBoughtReport: _propTypes["default"].func.isRequired,
  setSoldReport: _propTypes["default"].func.isRequired,
  form: _propTypes["default"].object
};
ReportBlockTradeSidePane.defaultProps = {
  onSidePaneOpen: function onSidePaneOpen() {}
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("core")(ReportBlockTradeSidePane);